{
  "id": "paises-bacen",
  "nome": "NF-e Bacen Country Codes",
  "fonte": "Banco Central FTP paises.txt + NF-e supplemental codes",
  "endpoints": [
    "http://www.nfe.fazenda.gov.br/portal/exibirArquivo.aspx?conteudo=PfPDd6dW200=",
    "http://www.nfe.fazenda.gov.br/portal/listaConteudo.aspx?tipoConteudo=/NJarYc9nus=",
    "https://www.bcb.gov.br/ftp/paises.txt"
  ],
  "capturadoEm": "2026-08-11",
  "atualizadoEm": "2026-08-11T05:04:23.432Z",
  "contagens": {
    "paises": 260
  },
  "alteracoes": {
    "adicionados": 11,
    "removidos": 4,
    "alterados": 33,
    "comparadoCom": "2026-08-05"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-11T05:04:23.432Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#paises-bacen"
}
